/* v3 `acctProfile` "Dónde participas": the bordered mini-list of the person's places. */
.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  list-style: none;
}

.row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  font-size: var(--font-size-13);
}

.row:last-child {
  border-bottom: 0;
}

.name {
  flex: 1;
  min-inline-size: 0;
  overflow-wrap: anywhere;
}
